import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ToastProvider } from './components/Toast';
import { AuthProvider } from './components/AuthContext';
import { CategoriesProvider } from './components/CategoriesContext';
import { MunicipalitiesProvider } from './components/MunicipalitiesContext';
import { BrowserRouter } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import { initAnalytics } from './utils/analytics';

console.log(
  `%c[env] REACT_APP_ENV=${process.env.REACT_APP_ENV} NODE_ENV=${process.env.NODE_ENV} API=${process.env.REACT_APP_API_URL}`,
  'color:#4a674a;font-weight:bold'
);

initAnalytics();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ToastProvider>
        <AuthProvider>
          <CategoriesProvider>
            <MunicipalitiesProvider>
              <App />
            </MunicipalitiesProvider>
          </CategoriesProvider>
        </AuthProvider>
      </ToastProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
